<template>
<div class="favourites-container">
    <div class="header">
        <h2 style="margin: 0;">{{ $t('favourites.title') }}</h2>
        <p style="margin: 0;">{{ $t('favourites.caption') }}</p>
    </div>
    <FavouritesSearch />
    <div class="favourites" v-if="pois.length > 0">
        <TripPoi v-for="poi in pois" :key="poi.id" :poi="poi" action="like" @change="getFavourites" />
        <div v-if="after !== null" :key="after" ref="infiniteScrollSpinner" style="display: flex; justify-content: center; margin: 20px 0;">
            <i class='bx bx-loader-alt bx-spin' style="font-size: 2rem;"></i>
        </div>
    </div>
    <div v-else style="display: flex; flex-direction: column; gap: 20px; align-items: center;">
        <img src="../../assets/images/no_favourites.png" style="width: 50%;"/>
        <h3>{{ $t('favourites.noFavourites') }}</h3>
    </div>
</div>
</template>

<script>
import TripPoi from '../TripPoi.vue';
import NewTripDialog from '../dialogs/NewTripDialog.vue';
import FavouritesSearch from '../FavouritesSearch.vue';
import {
    GlobalEventEmitter
} from '@/utils/GlobalEventEmitter'
import {
    apiCall
} from '@/utils/ApiMiddleware.js';

export default {
    name: "favourites",
    props: {},
    components: {
        TripPoi,
        FavouritesSearch
    },

    data() {
        return {
            pois: [],
            result: null,
            after: null,
            observer: null,
            loadingNext: false,
            searchFilters: {
                only_liked_by_me: true,
                limit: 10,
                search: '',
            }
        }
    },

    async mounted() {
        this.getFavourites();

        this.$nextTick(() => {
            const spinner = this.$refs.infiniteScrollSpinner;
            if (spinner) {
                this.observer = new IntersectionObserver((entries) => {
                    console.log('IntersectionObserver:', entries[0]);
                    if (entries[0].isIntersecting && this.after !== null && !this.loadingNext) {
                        this.loadNextPage();
                    }
                });
                this.observer.observe(spinner);
            }
        });
    },

    created() {
        GlobalEventEmitter.$on('doFavouritesSearch', (e) => { this.searchPois(e, true) })
    },

    beforeDestroy() {
        GlobalEventEmitter.$off('doFavouritesSearch')
        if (this.observer) {
            this.observer.disconnect();
        }
    },
    methods: {

        async getFavourites() {
            const loading = this.$vs.loading();
            this.after = null;
            this.result = null;
            await this.searchPois(this.searchFilters, true);
            this.setupObserver();
            loading.close();
        },
        newTrip() {
            GlobalEventEmitter.$emit('showDialog', NewTripDialog, this.newTripCallback) // chiedo il nome
        },
        newTripCallback(e) {
            if (e != null && e.length > 0) { // ha scelto un nome per il viaggio e ha premuto "prosegui" (non annulla)
                this.$router.push({
                    name: 'Viaggio'
                })
            }
        },

        async searchPois(p, reset = false) {
            // use apiCall to make a request to /pois
            const params = { ...p };
            if (!reset && this.after) {
                params.after = this.after;
            }
            const response = await apiCall('GET', '/pois', params);
            GlobalEventEmitter.$emit('favouritesSearchComplete');

            if (response.status == 200) {
                this.result = response.data;
                this.after = response.data.after || null;
                if (reset) {
                    this.pois = [];
                }
                if (response.data.data != null) {
                    this.pois = this.pois.concat(response.data.data);
                }
            } else if (response.status != 0) {
                this.$vs.notification({
                    title: this.$t('common.messages.somethingWentWrong'),
                    text: this.$t('favourites.messages.unableToLoadFavourites'),
                    color: 'danger',
                    position: 'top-right'
                });
            }
        },
        async loadNextPage() {
            if (this.loadingNext || this.after === null) return;
            this.loadingNext = true;
            await this.searchPois(this.searchFilters, false);
            this.loadingNext = false;
            this.$nextTick(() => {
                const spinner = this.$refs.infiniteScrollSpinner;
                if (spinner && this.observer) {
                    this.observer.observe(spinner);
                }
            });
        },

        setupObserver() {
            if (this.observer) {
                this.observer.disconnect();
            }
            this.$nextTick(() => {
                const spinner = this.$refs.infiniteScrollSpinner;
                if (spinner) {
                    this.observer = new IntersectionObserver((entries) => {
                        console.log('IntersectionObserver:', entries[0]);
                        if (entries[0].isIntersecting && this.after !== null && !this.loadingNext) {
                            this.loadNextPage();
                        }
                    });
                    this.observer.observe(spinner);
                }
            });
        }
    }
}
</script>

<style scoped>
.header {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;

}

.favourites {
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.favourites-container {

    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 20px;
}

/* MOBILE */
@media (max-width: 600px) {
    .favourites-container {
        padding-left: 20px;
        padding-right: 20px;
        padding-top: 20px;
        box-sizing: border-box;
        padding-bottom: 80px!important;
height: unset!important;
        width: 100%!important;
    }

}
</style>
